module.exports = __webpack_public_path__ + "static/media/Bushes_Black.2216881c.webp";